import React from 'react';
import './BottomLayout.less';
import HwzComponent from '../../common/component/HwzComponent';
import Moon from '../../common/model/global/Moon';
import DefaultLogoPng from '../../assets/image/logo.png';
import Sun from '../../common/model/global/Sun';
import Lang from '../../common/model/global/Lang';
import Capacity from './widget/Capacity';
interface IProps {}

interface IState {}

export default class BottomLayout extends HwzComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  static changeLang() {
    if (Lang.getSingleton().lang === 'zh') {
      Lang.getSingleton().lang = 'en';
    } else {
      Lang.getSingleton().lang = 'zh';
    }
    localStorage.setItem('_lang', Lang.getSingleton().lang);
    Sun.updateFrame();
  }

  render() {
    const { preference } = Moon.getSingleton();

    return (
       <div className="layout-bottom" >
        <div className="bottom-content"> 

        <span> 
        <Capacity /> 
        </span>
        <span className="item">
          <span dangerouslySetInnerHTML={{ __html: preference.copyright }} />
        </span>
        <span className="item">
          <span dangerouslySetInnerHTML={{ __html: preference.record }} />
        </span>
        <span className="item">
          <a className="text-theme" onClick={BottomLayout.changeLang}>
            {Lang.getSingleton().lang === 'zh' ? 'English' : '中文'}
          </a>
        </span>
        <span className="brand">
          Powered by{' '}
          <a target="_blank" href="http://www.hanweizhe.net">
            <img alt="logo" className="w30" src={DefaultLogoPng} />{' '}
            {Lang.t('ProductBand')}
          </a>
        </span>
        </div>
      </div>
    );
  }
}
